import React from "react";
import { PieChart, Pie, Cell, Legend, ResponsiveContainer } from "recharts";

interface DataItem {
  name: string;
  value: number;
  color: string;
}

interface StrategyPieChartProps {
  data: DataItem[];
}

const renderLegendText = (value: string, entry: any) => {
  return `${value} ${entry.payload.value}%`;
};

const StrategyPieChart = ({ data }: StrategyPieChartProps) => {
  return (
    <div className="w-full h-[280px]">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={false}
            outerRadius={80}
            dataKey="value"
            startAngle={90}
            endAngle={-270}
          >
            {data.map((entry, index) => (
              <Cell 
                key={`cell-${index}`} 
                fill={entry.color}
                stroke="white"
                strokeWidth={2}
              />
            ))}
          </Pie>
          <Legend 
            formatter={renderLegendText}
            iconType="circle"
            iconSize={8}
            layout="horizontal"
            align="center"
            wrapperStyle={{
              paddingTop: "20px",
              fontSize: "13px",
              width: "100%",
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: "12px 24px"
            }}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default StrategyPieChart;